import { render, staticRenderFns } from "./IconsBlock.vue?vue&type=template&id=058f50e1&scoped=true"
import script from "./IconsBlock.vue?vue&type=script&lang=js"
export * from "./IconsBlock.vue?vue&type=script&lang=js"
import style0 from "./IconsBlock.vue?vue&type=style&index=0&id=058f50e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058f50e1",
  null
  
)

export default component.exports